import AmpersandStateExtended from 'src/core/gd-model/ampersand-state-extended';
import ProjectProperties from 'core/model2/project/properties/project-properties';
import TaskTypesLookup from "src/core/model2/project/inheritance/task-types";
import ProjectStatusesLookup from "core/model2/project/inheritance/project-statuses";
import ProjectViewsLookup from "core/model2/project/inheritance/project-views-lookup";
import TasksStatusesLookup from "src/core/model2/project/inheritance/task-statuses";
import CRMAccountLookup from "src/core/model2/project/inheritance/crm-account";
import canCreateProject from "core/model2/project/access/create-project";
import canCreateTask from "core/model2/project/access/create-task";
import Project from "core/model2/project/project";
import canAddProjectUsers from "../../model2/project/access/can-add-project-users"
import canCreateEvent from "../../model2/project/access/create-event"

const ProjectModelSession = AmpersandStateExtended.extend({

    props: {
        id: 'string',
        name: 'string',
        icon: 'string',
        color: 'number',
        companyId: 'string',
        parentId: 'string',
        projectIcon: 'string',

        role: 'number', // user role in cur project
        access: 'number', // user access in cur project

        accessMode: 'number',

        shortName: 'string',
        systemStatus: 'number',
        systemType: 'number',
        projectTypeId: 'string',
        statusId: 'string',
        // defaultView: 'string',  - I think we don't need it anymore
        properties: 'object', // ok po hodu edinstvennii use seichas eto treatAsCatalog ... v celom vozmozno eto nado ostavit' - kto znaet chto eche v session data budet nuzno
        taskStatusesOverride: 'array',

        description: 'string',

        customFields: {
            type: 'array',
            default: () => []
        },

        taskTypes: {
            type: 'array',
            default: () => []
        },

        isDeleted: 'boolean',
        isTemplate: 'boolean',               //projects only
        templateContent: {
            type: 'object',
            default: () => ({
                customFields:   false,
                events:         false,
                subProjects:    false,
                subTasks:       false,
                tasks:          false,
            })
        },                                  //templates only

        localTemplateId: 'string',          //projects only
        sharedTemplateId: 'string',         //templates only

        statuses: 'array',
        sortPosition: 'number',

        settings: 'object',

        crmAccountId: 'string',
    },

    derived: {

        rid: {
            deps: ['id'],
            fn: function() {
                return 'p-'+this.id
            }
        },


        isTag: {
            deps: ['systemType'],
            fn: function() {
                return (this.systemType === gd.const.project.type.TAG)
            }
        },


        // path for older version support
        initials: {
            deps: ['name, shortName'],
            fn: function() {

                if (this.shortName) {
                    return this.shortName;
                } else {
                    console.error("NO SHORT NAME IN PROJECT SESSION MODEL",this);
                    return gd.utils.initials(this.name,3);
                }
            }
        },

        isArchived: {
            deps: ['systemStatus'],
            cache: false,
            fn: function() {
                return (gd.const.systemStatus.isClosed(this.systemStatus));
            }
        },

        systemStatusName: {
            deps: ['systemStatus'],
            fn: function() {
                return gd.const.systemStatusList[this.systemStatus];
            }
        },

        url: {
            deps: ['id'],
            fn: function() {
                return "p/"+this.id;
            }
        }
    },

    getInheritedTaskTypes()     {return new TaskTypesLookup(this.id).get()},
    getInheritedStatuses()      {return new ProjectStatusesLookup(this.id).get()},
    getInheritedTaskStatuses()  {return new TasksStatusesLookup(this.id).get()},
    getInheritedViews()         {return new ProjectViewsLookup(this.id).get()},
    getInheritedCRMAccount()    {return new CRMAccountLookup(this.id).get()},

    canCreateTask() {
        return canCreateTask(this)
    },

    canCreateProject() {
        return canCreateProject(this)
    },

    canCreateEvent() {
        return canCreateEvent(this)
    },

    canAddProjectUsers() {
        return canAddProjectUsers(this)
    },

    toModel() {

        return new Project(this)

    },

    parse(obj) {
        obj.properties = ProjectProperties.normalize(obj.properties);

        // Fix access ?
        if (obj.isTemplate && !obj.access) {
            // Eto ne rabotaet izza initialization... netu eche access... blin
            // if (gd.ac.check.company.isManager()) {
            //     obj.access = 3    // full
            // } else {
            //     obj.access = -10  // read only
            // }
            // nichego tut ne delau poka - smotri project proto app
        }

        return obj;
    }
});

module.exports = ProjectModelSession;
